import styled from "styled-components";

import {
  DATA_E2E_KEY,
  IStyledAttributes,
  LEFT_BAR_WIDTH,
  SESSION_GATE_LOADER_MS,
} from "@ryde/shared";
import { rydeColors, ScreenDepth } from "@ryde/theme";

export const AppBootstrapLoaderStyled = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "app-bootstrap-loader",
})<{ $isVisible: boolean; $shouldLeaveLeftBar: boolean }>`
  position: fixed;
  inset: 0;
  inset-inline-start: ${({ $shouldLeaveLeftBar }) =>
    $shouldLeaveLeftBar ? `${LEFT_BAR_WIDTH}px` : 0};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  width: ${({ $shouldLeaveLeftBar }) =>
    $shouldLeaveLeftBar ? `calc(100% - ${LEFT_BAR_WIDTH}px)` : "100%"};
  background-color: ${rydeColors.white};
  z-index: ${ScreenDepth.CONTENT_BLUR_OVERLAY};
  opacity: ${({ $isVisible }) => ($isVisible ? 1 : 0)};
  visibility: ${({ $isVisible }) => ($isVisible ? "visible" : "hidden")};
  pointer-events: ${({ $isVisible }) => ($isVisible ? "auto" : "none")};
  transition:
    opacity ${SESSION_GATE_LOADER_MS.overlayFadeMs}ms ease,
    visibility ${SESSION_GATE_LOADER_MS.overlayFadeMs}ms ease;

  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }
`;
